function loadReviewsIO() {
  let reviewsIOObserver;

  function loadCSS(href) {
    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = () => resolve();
      link.onerror = () => reject(new Error(`Failed to load CSS: ${href}`));
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      document.head.appendChild(script);
    });
  }

  function initializeRatingSnippet() {
    try {
      if (typeof ratingSnippet === 'function') {
        const themeVariant =
          window.settings?.theme_variant ||
          document.querySelector('[data-theme-variant]')?.dataset.themeVariant ||
          'mackenzie';

        const storeName = themeVariant === 'mackenzie' ? 'mackenzie-ltd.' : 'chesapeake-crab-cakes';

        ratingSnippet('ruk_rating_snippet', {
          store: storeName,
          mode: 'default',
          color: '#0E1311',
          linebreak: false,
          text: 'Reviews',
          singularText: 'Review',
          lang: 'en',
          usePolaris: true,
          showEmptyStars: false,
          enableSyndication: true,
        });
      }
    } catch (error) {
      //
    }
  }

  function setupReviewsIOObserver() {
    const targetContainer = document.querySelector('.kuSearchResultsPageContainer');

    if (!targetContainer) {
      setTimeout(setupReviewsIOObserver, 5000);
      return;
    }

    if (reviewsIOObserver) {
      reviewsIOObserver.disconnect();
    }

    reviewsIOObserver = new MutationObserver(function (mutations) {
      let shouldReinitializeReviews = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          shouldReinitializeReviews = true;
        }
      });

      if (shouldReinitializeReviews) {
        clearTimeout(window.reviewsReinitTimeout);
        window.reviewsReinitTimeout = setTimeout(async function () {
          if (typeof window.updateGroupedProductRatingSkus === 'function') {
            await window.updateGroupedProductRatingSkus();
          } else {
            initializeRatingSnippet();
          }
        }, 300);
      }
    });

    reviewsIOObserver.observe(targetContainer, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });
  }

  // Reviews.io injects its own standalone Product JSON-LD (#reviewsWidgetProductSnippets) with no
  // @id, which duplicates the canonical Product node emitted by snippets/pdp-schema.liquid. That
  // node already carries aggregateRating from the reviews.* metafields, so the injected one is
  // redundant. Watch for it and remove it so the PDP keeps a single Product node. See CFF-214.
  function removeDuplicateReviewSchema() {
    const node = document.getElementById('reviewsWidgetProductSnippets');
    if (node) node.remove();
  }

  const schemaDedupeObserver = new MutationObserver(removeDuplicateReviewSchema);
  schemaDedupeObserver.observe(document.documentElement, { childList: true, subtree: true });
  removeDuplicateReviewSchema();

  Promise.all([
    loadCSS('https://widget.reviews.co.uk/rating-snippet/dist.css'),
    loadScript('https://widget.reviews.co.uk/rating-snippet/dist.js'),
    loadScript('https://widget.reviews.io/product/dist.js'),
  ])
    .then(() => {
      setTimeout(() => {
        initializeRatingSnippet();
        setupReviewsIOObserver();
      }, 500);
    })
    .catch((error) => {
      //
    });
}

window.loadReviewsIO = loadReviewsIO;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadReviewsIO);
} else {
  loadReviewsIO();
}
